
var accountLoader = new LoaderState(vue.data.account);
var apiAccount = new ApiMonizze(accountLoader, 'account');
var expiredStorage = new ExpiredStorage();

/**
 * Load the account data from the api
 */
window.loadAccountData = function(customerId, key, duration, callback)
{
	if (!customerId)
	{
		// no customer, nothing to load, end
		accountLoader.setLoadingState(false);
		return;
	}

	apiAccount.getDataFromApi(
		urls.customerLight.replace('{customer}', customerId),
		function (data)
		{
			expiredStorage.setJson(key, data, duration);
			callback(data);
			return data;
		}
	);
};

/**
 * Remove data from local storage to refresh data
 */
window.removeAccountFromLocalStorage = function(customerId)
{
	localStorage.removeItem('account_'+customerId);
	return;
};

/**
 * Load customer data from storage or api
 */
window.loadCustomerData = function(customerId, callback, updateCache)
{
	var key = 'account_' + customerId;

	// If we have a version in cache we quickly load it
	if (expiredStorage.hasValidKey(key))
	{
		callback(expiredStorage.getJson(key));

		// If we don't need to update the cache version we have nothing more to do
		if (!updateCache)
		{
			return;
		}
	}

	// If we don't have the value in cache, or if we need to be sure to have the last version we do the real call

	// 4 hours
	var duration = 4 * 60 * 60;
	loadAccountData(customerId, key, duration, callback);
};

/**
 * Load the current customer information
 */
window.loadCurrentCustomerData = function()
{
	accountLoader.setLoadingState(true);
	loadCustomerData(
		vue.data.account.selectedCustomer.id,
		function (data)
		{
			data.id = data.customer_id;
			Vue.set(vue.data.account, 'selectedCustomer', data);
			accountLoader.setLoadingState(false);
		},
		true
	);
};

/**
 * Load the last three customers
 */
window.loadLastThreeCustomerData = function()
{
	var loadStates = vue.data.account.recentCustomers.ids.length;
	vue.data.account.recentCustomers.ids.forEach(function(customerId, index)
	{
		if (customerId == vue.data.account.selectedCustomer.id)
		{
			return;
		}

		loadCustomerData(customerId, function(data)
		{
			vue.data.account.recentCustomers.data[ index ] = {
				id: data.customer_id,
				name: data.name,
				postal_code: data.address.postal_code,
				city: data.address.city,
			};
			loadStates--;
			if (loadStates <= 0)
			{
				vue.data.account.recentCustomers.loading = false;
			}
		});
	})
};

/**
 * Save the last new recent customer we switch on
 */
window.setNewRecentCustomer = function(customerId)
{
	// check not the same
	if (customerId == vue.data.account.selectedCustomer.id)
	{
		return;
	}

	// we assure that the last one is always at the end of the recent one
	var recent = vue.data.account.recentCustomers.ids;

	var index = recent.indexOf(customerId);
	if (index !== false)
	{
		delete recent[ index ];
	}

	// remove the empty slot to avoid any issue
	recent = recent.flat();

	// be sure we only have maximum 3 elements
	recent = recent.splice(-3);
	recent = recent.flat();

	// add the current one to keep it for the future
	recent.push(customerId);

	Vue.set(vue.data.account.recentCustomers, 'ids', recent);
	localStorage.setItem('recentCustomers-' + vue.data.account.id, JSON.stringify(vue.data.account.recentCustomers.ids));
};

window.loadRecentCustomerFromCache = function()
{
	let data = localStorage.getItem('recentCustomers-' + vue.data.account.id);
	if (!data)
	{
		return;
	}
	try
	{
		data = JSON.parse(data);
	}
	catch (e)
	{
		return;
	}

	if (!data)
	{
		return;
	}

	Vue.set(vue.data.account.recentCustomers, 'ids', data);
};
